"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipBody = TooltipBody;
var _react = _interopRequireDefault(require("react"));
var _BaseTooltipHeader = require("../../baseComponents/BaseTooltip/__BaseTooltipHeader");
var _BaseTooltipContent = require("../../baseComponents/BaseTooltip/__BaseTooltipContent");
var _BaseTooltipFooter = require("../../baseComponents/BaseTooltip/__BaseTooltipFooter");
var _BaseTooltipLink = require("../../baseComponents/BaseTooltip/__BaseTooltipLink");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function TooltipBody(_ref) {
  var classes = _ref.classes,
    header = _ref.header,
    content = _ref.content,
    href = _ref.href;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, header && /*#__PURE__*/_react.default.createElement(_BaseTooltipHeader.__BaseTooltipHeader, {
    classes: classes.header
  }, header), /*#__PURE__*/_react.default.createElement(_BaseTooltipContent.__BaseTooltipContent, {
    classes: classes.content
  }, content), href && /*#__PURE__*/_react.default.createElement(_BaseTooltipFooter.__BaseTooltipFooter, {
    classes: classes.footer
  }, /*#__PURE__*/_react.default.createElement(_BaseTooltipLink.__BaseTooltipLink, {
    link: href
  }, "Link")));
}